module.exports = __webpack_public_path__ + "img/6.6700f504.png";